import { css } from 'styled-components'

/**
 * Contentful pages only. The CMS colour dropdown is fixed at white/grey/dark, so
 * teal reuses the `dark` slot rather than adding a fourth Contentful option that every
 * existing entry would have to be re-authored to pick up.
 *
 * Text keeps paletteType=inverse, which already supplies the white contrast teal needs.
 */
export const rebrandTealDarkBackground = css`
  &&.background-color-dark {
    background-color: var(--palette-highlight-primary-dark-background);
  }
`
